import React , {Component} from 'react';
import {
     Link
} from 'framework7-react';
class EventCard extends Component{

    render(){
        const { object } = this.props;
        return(
            <Link href={object.url} className="event-card" external target="_blank">
                <div className="b-row ">
                    <div className="b-col-3">
                        <div className="img-container">
                            <img src={object.thumbnailUrl}/>
                        </div>
                    </div>
                    <div className="b-col-9">
                        <div className="title">
                            {object.Title}
                        </div>
                        <div className="date">
                            {object.created_at_date}
                        </div>
                    </div>
                </div>
            </Link>
        )
    }
}

export default EventCard;